import React from 'react';
import { Button, CssBaseline, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography, withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import SubTitle from '../components/Text/SubTitle';

const styles = (theme) => ({
  message: {
    padding: theme.spacing(2, 0, 5),
    color: '#555',
    textAlign: 'justifyContent',
    '& p': {
      marginBottom: '1.2em',
    },
  },
  divLine: {
    width: '100%',
    height: '1px',
    margin: theme.spacing(7, 0),
    backgroundColor: 'rgba(0,0,0,0.1)',
  },
});

const StyledTableRow = withStyles((theme) => ({
  root: {
    color: '#000000',
    wordBreak: 'keep-all',
    '& th': { textAlign: 'center', fontWeight: 'bold', fontSize: '1.2em' },
    '& td': {
      fontWeight: 500,
      fontSize: '1.2em',
      '& p': {
        textIndent: '-0.65em',
        paddingLeft: '0.6em',
      },
    },
    // '&:nth-of-type(odd)': {
    //   '& th': {
    //     backgroundColor: '#cfdae6',
    //   },
    //   '& td': {
    //     backgroundColor: '#e6edf6',
    //   },
    // },
    // '&:nth-of-type(even)': {
    //   '& th': {
    //     backgroundColor: '#e9eff5',
    //   },
    //   '& td': {
    //     backgroundColor: '#f4f7fa',
    //   },
    // },
  },
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
  root: {
    border: '2px solid',
    borderColor: '#fff',
    fontSize: '1.2em',
    fontWeight: 500,
    // padding: '8px 0',
    backgroundColor: '#e9eef1',
    textAlign: 'center',
    wordBreak: 'keep-all',
  },
}))(TableCell);

class Visa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:992px)').matches,
    };
  }

  componentDidMount() {}

  render() {
    const { theme } = this.props;
    const Content_padding_s = 16;
    // const Content_padding = 24;
    const Content_padding_l = 48;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={7} SIdx={4} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid container item xs={11} sm={10} md={9} lg={8}>
              <Grid item xs={12}>
                <MainTitle>Visa</MainTitle>
              </Grid>
              {/* 1 */}
              <Grid container alignItems="center" style={{ paddingBottom: Content_padding_l }}>
                <SubTitle>Ministry of Foreign Affairs and Trade</SubTitle>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => {
                    window.open('https://www.mofa.go.kr/eng/index.do', '_blank');
                  }}
                  style={{ color: '#fff', fontSize: 'large', marginLeft: 16, textTransform: 'none' }}
                >
                  Link
                </Button>
              </Grid>
              {/* 2 */}
              <Grid container style={{ paddingBottom: Content_padding_l }}>
                <SubTitle>Immigration Bureau</SubTitle>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => {
                    window.open('https://www.immigration.go.kr/immigration_eng/index.do', '_blank');
                  }}
                  style={{ color: '#fff', fontSize: 'large', marginLeft: 16, textTransform: 'none' }}
                >
                  Link
                </Button>
                <Grid container style={{ paddingTop: Content_padding_s }}>
                  <Typography style={{ fontSize: '1.2em', lineHeight: 1.6 }}>
                    All visitors to Korea must have a valid passport and visa before coming. Visitors from countries that have a special
                    agreement with Korea are exempt from the visa requirement and allowed to stay in Korea without a visa for 30 days or up
                    to 90 days, depending on agreements. For more information, please contact the local Korean consulate or embassy, or
                    visit the official website of the Korean Ministry of Foreign Affairs and Trade.
                  </Typography>
                </Grid>
              </Grid>
              {/* 3 */}
              <Grid container style={{ paddingBottom: Content_padding_l }}>
                <SubTitle>Countries under visa exemption agreements</SubTitle>
                <Table style={{ marginTop: Content_padding_s }}>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        width={'15%'}
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Total
                      </StyledTableCell>
                      <StyledTableCell
                        width={'15%'}
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Passport Type
                      </StyledTableCell>
                      <StyledTableCell
                        colSpan={2}
                        width={'70%'}
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Countries
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell rowSpan={7}>
                        103 countries
                        <br />
                        (up to 90 Days unless noticed otherwise)
                      </StyledTableCell>
                      <StyledTableCell>
                        Diplomatic
                        <br />
                        (2 countries)
                      </StyledTableCell>
                      <StyledTableCell colSpan={2}>Turkmenistan (30 days), Ukraine (90 days)</StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell>
                        Diplomatic & Official
                        <br />
                        (35 countries)
                      </StyledTableCell>
                      <StyledTableCell colSpan={2}>
                        Algeria, Argentina, Azerbaijan (30 days), Bangladesh, Belarus, Belize, Benin, Cambodia (60 days), China (30 days),
                        Cyprus, Croatia, Ecuador (Diplomatic: as needed for work performance, Official: 3 months), Egypt, Gabon, India, Iran
                        (3 months), Japan (3 months), Kuwait, Laos, Mongolia, Pakistan (3 months), Paraguay, the Philippines (Unlimited),
                        Uzbekistan (60 days), Uruguay, Vietnam, Moldova (90 days within 180 days), Tajikistan, Georgia, Myanmar, Bolivia,
                        Kyrgyz (30 days), Armenia, Angola (30 days), Oman
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell rowSpan={5}>
                        Diplomatic & Official & Ordinary
                        <br />
                        (66 countries)
                      </StyledTableCell>
                      <StyledTableCell width={'20%'}>
                        Asia
                        <br />
                        (4 countries)
                      </StyledTableCell>
                      <StyledTableCell width={'50%'}>Malaysia, New Zealand, Singapore, Thailand</StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell>
                        America
                        <br />
                        (25 countries)
                      </StyledTableCell>
                      <StyledTableCell>
                        Antigua and Barbuda, Bahamas, Barbados, Brazil, Chile, Colombia, Commonwealth of Dominica, Costa Rica, Dominican
                        Republic, El Salvador, Grenada, Guatemala, Haiti, Jamaica, Mexico, Nicaragua, Panama, Peru, Saint Kitts and Nevis,
                        Saint Lucia, Saint Vincent and the Grenadines, Suriname, Trinidad and Tobago, Venezuela (Diplomatic/Official: 30
                        days, Ordinary: 90 days), Uruguay
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell rowSpan={2}>
                        Europe
                        <br />
                        (32 countries)
                      </StyledTableCell>
                      <StyledTableCell>
                        [Schengen countries (except for Slovenia out of the 26 Schengen countries)], Austria (Diplomatic/Official: 180
                        days), Belgium, Czech Republic, France, Germany, Greece, Hungary, Italy, Liechtenstein, Lithuania, Latvia,
                        Luxemburg, Malta, Netherlands, Poland, Portugal (60days), Slovakia, Spain, Switzerland ※ Denmark, Estonia, Finland,
                        Iceland, Norway, Sweden (90 days within 180 days)
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell>
                        [Non-Schengen countries] Bulgaria, Ireland, Romania, Turkey, UK, Kazakhstan ※ Russia (60 days in a row, not
                        exceeding 90 days within 180 days)
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell>
                        Africa & Middle East
                        <br />
                        (5 countries)
                      </StyledTableCell>
                      <StyledTableCell>Israel, Liberia, Morocco, Tunisia (30 days), Lesotho (60 days)</StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </Grid>
              {/* 4 */}
              <Grid container style={{ paddingBottom: Content_padding_l }}>
                <SubTitle>Nationals of countries or regions allowed for visa-free entry (30/90) days unless noticed other</SubTitle>
                <Table style={{ marginTop: Content_padding_s }}>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        width={'20%'}
                        style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                      >
                        Continents
                      </StyledTableCell>
                      <StyledTableCell
                        width={'80%'}
                        style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                      >
                        Countries or Regions
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        Asia or regions
                        <br />
                        (6 countries)
                      </StyledTableCell>
                      <StyledTableCell>
                        Brunei (30 days), Hong Kong (90 days), Indonesia (diplomatic and official 30 days), Japan (90 days), Macau (90
                        days), Taiwan (90 days)
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        America
                        <br />
                        (7 countries)
                      </StyledTableCell>
                      <StyledTableCell>
                        Argentina (30 days), Canada (6 months), Ecuador (90 days), Guyana (30 days), Honduras (30 days), Paraguay (30 days),
                        United States (90 days)
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell align="center">
                        Europe
                        <br />
                        (11 countries)
                      </StyledTableCell>
                      <StyledTableCell>
                        Albania (30 days), Italy (30 days), Bosnia-Herzegovina (30 days), Croatia (90 days), Cyprus (30 days), Monaco (30
                        days), Montenegro (30 days), San Marino (30 days), Serbia (90 days), Slovenia (90 days), Vatican (30 days)
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell align="center">
                        Oceania or regions
                        <br />
                        (13 countries)
                      </StyledTableCell>
                      <StyledTableCell>
                        Australia (90 days), Fiji (30 days), Guam (30 days), Kiribati (30 days), Marshall Islands (30 days), Micronesia (30
                        days), Nauru (30 days), New Caledonia (30 days), Palau (30 days), Samoa (30 days), Solomon Islands (30 days), Tonga
                        (30 days), Tuvalu (30 days)
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell align="center">
                        Europe
                        <br />
                        (11 countries)
                      </StyledTableCell>
                      <StyledTableCell>
                        Albania (30 days), Italy (30 days), Bosnia-Herzegovina (30 days), Croatia (90 days), Cyprus (30 days), Monaco (30
                        days), Montenegro (30 days), San Marino (30 days), Serbia (90 days), Slovenia (90 days), Vatican (30 days)
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell align="center">
                        Middle East and Africa
                        <br />
                        (12 countries)
                      </StyledTableCell>
                      <StyledTableCell>
                        Bahrain (30 days), Egypt (30 days), Kuwait (30 days), Lebanon (diplomatic and official 30 days), Mauritius (30
                        days), Oman (30 days), Qatar (30 days), Saudi Arabia (30 days), Seychelles (30 days), South Africa (30 days),
                        Swaziland (30 days), United Arab Emirates (30 days)
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Visa);
